import React, { Component } from 'react';
import FranchiseListingsTable from './FranchiseListingsTable';
import { connect } from 'react-redux';
import {
  fetchAdminFranchiseListings,
  searchAdminFranchiseListings,
} from '../../state/actions/franchise';
import Pagination from './../../common/components/Pagination';
import { CircularProgress, Switch } from '@material-ui/core';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { CustomDatePicker } from './../../common/utils/helpers';
import withSizes from 'react-sizes';

class FranchiseListings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalFranchiseListings: 134155463264,
      totalApproved: 13415245235,
      totalPending: 1341252345,
      allFranchiseListings: [],
      loading: false,
      franchiseSearchString: '',
      searchPlaceholder: 'Franchise Name',
      status: '',
      byId: false,
      startDate: null,
      endDate: null,
    };
    this.ref = React.createRef();
  }

  componentDidMount() {
    this.props.fetchAdminFranchiseListings();
  }

  onPageChange = page => {
    const {
      byId,
      franchiseSearchString,
      status,
      startDate,
      endDate,
    } = this.state;
    if (typeof page === 'number') {
      this.setState({ loading: true });
      this.props.searchAdminFranchiseListings(
        startDate,
        endDate,
        franchiseSearchString,
        status,
        byId,
        page,
      );
    }
  };

  setStartDate(startDate) {
    this.setState({ startDate });
  }

  setEndDate(endDate) {
    this.setState({ endDate });
  }

  setFranchiseSearchString = searchString => {
    this.setState({ franchiseSearchString: searchString });
  };

  franchiseSearch = async e => {
    e.preventDefault();
    const {
      byId,
      franchiseSearchString,
      status,
      startDate,
      endDate,
    } = this.state;
    if (byId) {
      this.props.searchAdminFranchiseListings(
        startDate,
        endDate,
        franchiseSearchString,
        status,
        byId,
      );
    } else {
      this.props.searchAdminFranchiseListings(
        startDate,
        endDate,
        franchiseSearchString,
        status,
      );
    }
  };

  franchiseFilter = status => {
    const { byId, franchiseSearchString, startDate, endDate } = this.state;
    if (byId) {
      this.props.searchAdminFranchiseListings(
        startDate,
        endDate,
        franchiseSearchString,
        status,
        byId,
      );
    } else {
      this.props.searchAdminFranchiseListings(
        startDate,
        endDate,
        franchiseSearchString,
        status,
      );
    }
  };

  handleFilterChange = e => {
    const status = e.target.value;
    this.setState({ status });
    this.franchiseFilter(status);
  };

  onSwitch = async e => {
    const { checked } = e.target;
    this.setState({
      byId: checked,
      searchPlaceholder: checked ? 'Franchise ID' : 'Franchise Name',
    });
  };

  onPreviousPage = () => {
    const {
      byId,
      franchiseSearchString,
      status,
      startDate,
      endDate,
    } = this.state;
    this.setState({ loading: true });
    this.props.searchAdminFranchiseListings(
      startDate,
      endDate,
      franchiseSearchString,
      status,
      byId,
      this.props.pageNumber - 1,
    );
  };

  onNextPage = () => {
    const {
      byId,
      franchiseSearchString,
      status,
      startDate,
      endDate,
    } = this.state;
    this.setState({ loading: true });
    this.props.searchAdminFranchiseListings(
      startDate,
      endDate,
      franchiseSearchString,
      status,
      byId,
      this.props.pageNumber + 1,
    );
  };

  render() {
    const {
      adminFranchiseListings: allListings,
      pageNumber,
      pageSize,
      totalCount,
      loadingFranchiseListings,
      isMobile,
      isTablet,
    } = this.props;
    const { byId, searchPlaceholder, startDate, endDate } = this.state;
    return (
      <div className="admin-custom">
        <div className="ml-lg-5">
          <h1>Franchise Listings Overview</h1>
          <div className="w-50 my-3 border"></div>
          <div className="d-flex flex-wrap mb-5">
            <div className="d-flex flex-column justify-content-around w-100 w-lg-30 w-md-30 text-center bg-white shadow rounded-1 p-4 m-2">
              <p className="h6 mb-4">Total Franchises</p>
              <div className="h2 font-weight-bold text-primary">
                {loadingFranchiseListings ? (
                  <CircularProgress color="primary" size={'1rem'} />
                ) : (
                  totalCount
                )}
              </div>
            </div>
            <div className="d-block d-lg-none d-md-none w-100"></div>
            <div className="d-flex justify-content-around w-100 w-lg-60 w-md-60 text-center bg-white shadow rounded-1 p-2 m-2">
              <div className="d-flex flex-column justify-content-around">
                <p className="h6 mb-4">From</p>
                <div className="input-group px-2">
                  <DatePicker
                    todayButton="Today"
                    selected={startDate}
                    onChange={date => this.setStartDate(date)}
                    isClearable
                    customInput={<CustomDatePicker ref={this.ref} />}
                    withPortal={isMobile || isTablet}
                  />
                </div>
              </div>
              <div className="d-flex flex-column justify-content-around">
                <p className="h6 mb-4">To</p>
                <div className="input-group">
                  <DatePicker
                    todayButton="Today"
                    selected={endDate}
                    onChange={date => this.setEndDate(date)}
                    isClearable
                    customInput={<CustomDatePicker ref={this.ref} />}
                    withPortal={isMobile || isTablet}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="w-50 my-3 border"></div>

          <div className=" ml-3">
            <Switch
              color="primary"
              name="renewal"
              value={byId}
              checked={byId}
              onChange={e => this.onSwitch(e)}
            />
            {byId ? 'By Franchise ID' : 'By Franchise Name'}
          </div>

          <div className="d-flex flex-nowrap my-4">
            <div className="form-inline w-70">
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder={searchPlaceholder}
                  aria-label={searchPlaceholder}
                  aria-describedby="basic-addon2"
                  onChange={event =>
                    this.setFranchiseSearchString(event.target.value)
                  }
                />
                <div className="input-group-append">
                  <button
                    className="btn btn-outline btn-admin-primary"
                    type="button"
                    onClick={this.franchiseSearch}
                  >
                    Search
                  </button>
                </div>
              </div>
            </div>
            <select
              className="browser-default custom-select w-30"
              value={this.state.status}
              onChange={this.handleFilterChange}
            >
              <option value="">See All</option>
              <option value="Approved">Approved</option>
              <option value="Pending">Pending</option>
              <option value="ChangesRequired">Changes Required</option>
              <option value="Draft">Draft</option>
              <option value="Declined">Declined</option>
              <option value="Deleted">Deleted</option>
            </select>
          </div>
          <div className="d-flex justify-content-between w-lg-60 w-md-60 mb-3">
            <p className="h7 font-weight-normal m-0">Legend: &nbsp;</p>
            <div className="d-flex align-items-center">
              <div className="rounded-circle bg-danger mr-2 status"></div>
              <p className="h7 font-weight-normal m-0">Yet approved</p>
            </div>
            <div className="d-flex align-items-center">
              <div className="rounded-circle bg-warning mr-2 status"></div>
              <p className="h7 font-weight-normal m-0">Approval In progress</p>
            </div>
            <div className="d-flex align-items-center">
              <div className="rounded-circle bg-success mr-2 status"></div>
              <p className="h7 font-weight-normal m-0">Approved</p>
            </div>
          </div>
          <div className="profiles-table">
            <FranchiseListingsTable
              listings={allListings}
              loadingFranchiseListings={loadingFranchiseListings}
            />
            <div className="d-flex justify-content-center my-3">
              <Pagination
                currentPage={pageNumber}
                pageSize={pageSize}
                totalItem={totalCount}
                onPageChange={this.onPageChange}
                onPreviousPage={this.onPreviousPage}
                onNextPage={this.onNextPage}
                hideComponent={loadingFranchiseListings ? 'd-none' : ''}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapSizesToProps = sizes => ({
  isMobile: withSizes.isMobile(sizes),
  isTablet: withSizes.isTablet(sizes),
});

export default withSizes(mapSizesToProps)(
  connect(
    state => ({
      loadingFranchiseListings: state.franchise.loadingFranchiseListings,
      adminFranchiseListings: state.franchise.adminFranchiseListings,
      pageNumber: state.franchise.pageNumber,
      pageSize: state.franchise.pageSize,
      totalCount: state.franchise.totalCount,
    }),
    { fetchAdminFranchiseListings, searchAdminFranchiseListings },
  )(FranchiseListings),
);
